var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "sm", title: "Rejection Reason" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", { staticClass: "relative h-32" }, [
              _c("div", { staticClass: "w-full space-y-1" }, [
                _c("p", [_vm._v(" " + _vm._s(_vm.rejectionReason) + " ")]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }